import React, {useState} from "react";
import { Box } from "@mui/material";

import { useNavigate } from "react-router-dom";
// import MobileDrawer from "../MobileComponents/MobileDrawer";

// import ProfileBottomTab from "../MobileComponents/ProfileBottomTab";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import CreateIcon from "@mui/icons-material/Create";
// import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import EmailIcon from "@mui/icons-material/Email";
// import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { red } from '@mui/material/colors';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 10,
    p: 3,
  };
function MobileTenantVehicle() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [SelectOwner, setSelectOwner] = useState('');
    const handleChangeOwner = (event) => {
        setSelectOwner(event.target.value);
      };
    const [vehicleType, setVehicleType] = useState('');
    const handleChange = (event) => {
        setVehicleType(event.target.value);
    };
    const initialValues = {
      vehicle_number: "",
      model_color: "",
    };
  
    const validationSchema = Yup.object({
      vehicle_number: Yup.string().required("Required"),
      model_color: Yup.string().required("Required"),
    });
    const onSubmit = (values) => console.log("Form Data", values);
  return (
    <>
      <div>
        <div className="drawerFixedPatch"></div>
        <div className="drawerWithTop">
          {/* <MobileDrawer /> */}
          <ArrowBackIcon
            className="backArrowMobil"
            onClick={() => navigate("/MobileProfile")}
          />
          <h1>Tenant Vehicle List</h1>
        </div>
      </div>
      <div className="wraperMobile">
        <div className="sectionMobile">
        <div className="ParkingSlotView">
            <p className="ParkingSlotTxt">Assigned Parking Slot P-101</p>
        </div>
          <div className="famDetailsListMainMob">
            <div className="famDetailsListInrMob" onClick={() => navigate('/MobileTenantVehicleDetails')}>
              <div className="famDetailsListTo">
                <div className="alignfamDetailsListToPro" >
                 <div className="IconViewVehicle ">
                    <TwoWheelerIcon sx={{fontSize:28, color: "#ff5252"}} />
                 </div>
                  <div className="detailsDiMob">
                    <h1>FName LName</h1>
                    <div className="mobWithIco">
                      <p>MH 15 AA 1234</p>
                    </div>
                  </div>
                </div>
               {/*  <div className="listDeleEdiMob">
                  <CreateIcon style={{ color: "#21bd21" }} />
                  <DeleteOutlineIcon style={{ color: "#ff5252" }} />
                </div> */}
              </div>
            </div>
            
            <div className="famDetailsListInrMob" onClick={() => navigate('/MobileTenantVehicleDetails')}>
              <div className="famDetailsListTo">
                <div className="alignfamDetailsListToPro">
                 <div className="IconViewVehicle CarBackground">
                    <DirectionsCarIcon sx={{fontSize:28, color: "#21bd21"}} />
                 </div>
                  <div className="detailsDiMob">
                    <h1>FName LName</h1>
                    <div className="mobWithIco">
                      <p>MH 15 AA 1234</p>
                    </div>
                  </div>
                </div>
                {/* <div className="listDeleEdiMob">
                  <CreateIcon style={{ color: "#21bd21" }} />
                  <DeleteOutlineIcon style={{ color: "#ff5252" }} />
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className='flaotBtnAdd'>
            <Fab onClick={handleOpen} size="medium" sx={{backgroundColor: '#3853ec'}} aria-label="add" >
            <AddIcon sx={{fontSize: 32, color:'white'}}/>
            </Fab>
        </div>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
        <Box sx={style}>
          <div className='modalTitleView'>
            <p className='modalTitleTxt'>Add Vehicle Details</p>
            <CloseIcon sx={{ color: red[600], fontSize: 25 }} onClick={handleClose} />
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
          {(formik) => (
          <Form>
          <div className='FormView'>
            <div className='lebalInputView'>
            <p className='inputLebal'>Select Owner Name</p>
            <Select
                value={SelectOwner}
                onChange={handleChangeOwner}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                <MenuItem value={'Sagar Kasar'}>Sagar Kasar</MenuItem>
                <MenuItem value={'Kailas Gaikwad'}>Kailas Gaikwad</MenuItem>
                <MenuItem value={'Vaishali Jejurkar'}>Vaishali Jejurkar</MenuItem>
                </Select>
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Vehicle Number"
              placeholder="Enter Vehicle Number"
              labelclassName="inputLebal"
              name="vehicle_number"
              className="titleInput"
            />
            </div>
            <div className='lebalInputView'>
            <p className='inputLebal'>Vehicle Type</p>
            <Select
                value={vehicleType}
                onChange={handleChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                <MenuItem value={'TwoWheeler'}>Two Wheeler</MenuItem>
                <MenuItem value={'ThreeWheeler'}>Three Wheeler</MenuItem>
                <MenuItem value={'FourWheeler'}>Four Wheeler</MenuItem>
                </Select>
            </div>
            <div className='lebalInputView'>
            <FormikControl
              control="input"
              type="text"
              label="Make Model Color"
              placeholder="Enter Model Color"
              labelclassName="inputLebal"
              name="model_color"
              className="titleInput"
            />
            </div>
            <div className='attchmentView'>
              <AttachmentIcon sx={{ fontSize: 30, color: '#3853ec' }} />
              <input type='file' className='fileUploadButton'/>
              <p className='checkBoxTxt'>Document's</p>
            </div>
            <div className='attchmentView'>
              <p className='fileName'>File name</p>
              <CloseIcon sx={{ color: red[600], fontSize: 25 }} />
            </div>
            <button className='submitButton' type='submit'>Add Vehicle</button>
          </div>
          </Form>
            )}
          </Formik>
        </Box>
        </Modal>
      </div>
    </>
  )
}

export default MobileTenantVehicle